import { renderToStaticMarkup } from 'react-dom/server';
import React from 'react';
import CustomerEmail from '../../components/email/CustomerEmail';
import { OrderLineItem } from '../../queries/shopify/fragments/OrderLineItems';

function generateEmailContent(
  orderId: string,
  customerName: string,
  shipDate: Date,
  prevSentTime: number,
  items: OrderLineItem[],
  total: string,
  note: string
) {
  const doctype =
    '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">';

  return (
    doctype +
    renderToStaticMarkup(
      <CustomerEmail
        orderId={orderId}
        customerName={customerName}
        shipDate={shipDate}
        items={items}
        prevSentTime={prevSentTime}
        total={total}
        note={note}
      />,
    )
  );
}

export default generateEmailContent;
